import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export function NewsletterToggle({ endpoint = "/profile/newsletter", title = "Wochenrückblick per E-Mail", text = "Jeden Sonntag: das Beste der Woche und dein Punktestand.", label = "Wochenrückblick", testid = "newsletter" }) {
  const [on, setOn] = useState(null);
  useEffect(() => {
    const load = () => api.get(endpoint).then(({ data }) => setOn(data.enabled)).catch(() => {});
    load();
    window.addEventListener("email-consent-changed", load);
    return () => window.removeEventListener("email-consent-changed", load);
  }, [endpoint]);
  if (on === null) return null;
  const toggle = async (v) => {
    setOn(v);
    try { await api.put(endpoint, { enabled: v }); toast.success(v ? `${label} eingeschaltet 💌` : `${label} abbestellt`); }
    catch (e) { setOn(!v); toast.error(formatErr(e)); }
  };
  return (
    <div className="bg-white rounded-3xl p-6 border border-pink-100 flex items-start gap-4" data-testid={`${testid}-toggle`}>
      <span className="w-10 h-10 shrink-0 rounded-2xl bg-rose-50 text-rose-500 flex items-center justify-center"><Mail className="w-5 h-5" /></span>
      <div className="flex-1 min-w-0">
        <p className="font-bold">{title}</p>
        <p className="text-sm text-slate-500">{text}</p>
      </div>
      <Switch checked={on} onCheckedChange={toggle} data-testid={`${testid}-switch`} className="data-[state=unchecked]:bg-slate-300" />
    </div>
  );
}

export { SoundSettings as SoundToggle } from "@/components/SoundSettings";
